import templateDefaults from '../templateDefaults';

export default {
  previewImage: '/img/event/ticker.png',
  title: 'Ticker',
  templateData() {
    return {
      version: 'v1.1',
      title: 'Event Ticker',
      ...templateDefaults,
      elements: [
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Text',
          locked: false,
          text: '<p><strong>THIS IS THE TICKER TEXT AT 24PT. LOREM IPSUM DOLOR SIT AMET, CONSECTETUR ADIPISCING ELIT, SED DO EIUSMOD TEMPOR INCIDIDUNT.</strong><span class="ql-cursor">﻿</span></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 300,
          animationInDelay: 600,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 300,
          animationOutDelay: 0,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: true,
          tickerCrawlSpeed: 2000,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 1035,
            left: 60,
            width: 1800,
            height: 45,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Montserrat',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 24,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Gradient rectangle',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInLeft',
          animationInDuration: 300,
          animationInDelay: 0,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'slideOutLeft',
          animationOutDuration: 300,
          animationOutDelay: 600,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'gradient',
          backgroundColor: '#0F84FB',
          backgroundSize: 'cover',
          gradientDirection: 90,
          gradientColorOne: 'rgb(204, 0, 127)',
          gradientColorTwo: 'rgb(255, 208, 19)',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          skewX: 0,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 1029,
            left: 0,
            width: 1920,
            height: 6,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Black rectangle',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInLeft',
          animationInDuration: 300,
          animationInDelay: 300,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'slideOutLeft',
          animationOutDuration: 300,
          animationOutDelay: 300,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'solid',
          backgroundColor: 'rgb(17, 17, 17)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          skewX: 0,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 1035,
            left: 0,
            width: 1920,
            height: 45,
            opacity: 1,
          },
        },
      ],
    };
  },
};
